//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import BurgerMenuIcon from './BurgerMenuIcon.vue';
import BurgerMenuDrawer from './BurgerMenuDrawer.vue';

export default {
  props: {
    menu: Array,
    socialLinks: Object,
  },
  data() {
    return {
      shouldDisplayDrawer: false,
    };
  },
  computed: {
    structuredMenu: function() {
      if (this.menu.lengths <= 0) {
        return;
      }
      // Get all top level menu items first
      const parentMenuItems = this.menu
        .filter(({ menu_item_parent }) => parseInt(menu_item_parent, 10) === 0)
        .reduce(
          (items, parentItem) => ({
            ...items,
            [parentItem.ID]: { ...parentItem, childItems: [] },
          }),
          {}
        );

      // Map correct child menu items to their parents
      const parentMenuWithChildern = this.menu.reduce((acc, menuItem) => {
        const parentMenuId = parseInt(menuItem.menu_item_parent, 10);

        return parentMenuId
          ? {
              ...acc,
              [parentMenuId]: {
                ...acc[parentMenuId],
                children: acc[parentMenuId].childItems.push(menuItem),
              },
            }
          : acc;
      }, parentMenuItems);

      return Object.keys(parentMenuWithChildern)
        .reduce((acc, id) => [...acc, parentMenuWithChildern[id]], [])
        .sort((prev, next) => prev.menu_order - next.menu_order);
    },
  },
  methods: {
    openDrawer() {
      this.shouldDisplayDrawer = true;

      document.getElementsByTagName('body')[0].classList.add('hasOverlay');

      setTimeout(
        () =>
          document
            .getElementsByTagName('body')[0]
            .classList.add('hasOverlayActive'),
        300
      );
    },
    closeDrawer() {
      this.shouldDisplayDrawer = false;

      setTimeout(
        () =>
          document
            .getElementsByTagName('body')[0]
            .classList.remove('hasOverlayActive'),
        300
      );

      setTimeout(
        () =>
          document
            .getElementsByTagName('body')[0]
            .classList.remove('hasOverlay'),
        800
      );
    },
    keydownHandler(event) {
      if (event.keyCode === 27) {
        this.closeDrawer();
      }
    },
    clickOutsideHandler(event) {
      if (
        this.shouldDisplayDrawer &&
        !event.target.closest('.menu-burger--icon--wrapper') &&
        !event.target.closest('.menu_drawer__wrapper')
      ) {
        this.closeDrawer();
      }
    },
  },
  components: {
    'burger-menu-icon': BurgerMenuIcon,
    'burger-menu-drawer': BurgerMenuDrawer,
  },
  mounted: function() {
    window.addEventListener('keydown', this.keydownHandler);
    window.addEventListener('click', this.clickOutsideHandler);
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/burger-menu/BurgerMenu.vue